import { useTranslation } from 'react-i18next';

import { Button, Input } from 'antd';

import './BotTab.sass';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { BotMessage } from 'components/bot/BotMessage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldHalved } from '@fortawesome/pro-light-svg-icons';

interface BotTabProps {
    messages: any[];
    onSendMessage: Function;
    projectId?: string;
}

export const BotTab = (props: BotTabProps) => {
    const { t } = useTranslation();
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const bodyRef = useRef<HTMLDivElement>(null);

    const handleSendMessage = (callback) => {
        setLoading(true);
        props.onSendMessage(message, callback);
        setMessage("");
    };

    // Auto-scroll only when the user is already pinned near the bottom.
    // We capture the "near bottom" state BEFORE the DOM updates with the new
    // content, so a streaming delta doesn't push the user away from where they scrolled.
    const stickToBottomRef = useRef(true);
    useEffect(() => {
        const el = bodyRef.current;
        if (!el) return;
        const onScroll = () => {
            const distance = el.scrollHeight - el.scrollTop - el.clientHeight;
            stickToBottomRef.current = distance < 32;
        };
        el.addEventListener('scroll', onScroll, { passive: true });
        return () => el.removeEventListener('scroll', onScroll);
    }, []);

    const lastContent = props.messages[props.messages.length - 1]?.content;
    useLayoutEffect(() => {
        const el = bodyRef.current;
        if (el && stickToBottomRef.current) el.scrollTop = el.scrollHeight;
    }, [props.messages.length, lastContent]);

    return (
        <div className="BotTab">
            <div className="SecurityNotice">
                <FontAwesomeIcon icon={faShieldHalved} />
                <span>{t('messages.bot.security_notice')}</span>
            </div>

            <div className="BodyWrapper" ref={bodyRef}>
                {props.messages.map((message, index) => (
                    <BotMessage
                        key={index}
                        loading={message.loading}
                        content={message.content}
                        role={message.role}
                    />
                ))}
            </div>

            <div className='InputWrapper pt-1 pb-05'>
                <Input.TextArea
                    autoSize={{ minRows: 3, maxRows: 10 }}
                    className='input'
                    onChange={(e) => setMessage(e.target.value)}
                    value={message}
                    placeholder={t('messages.bot.placeholder')}
                />

                <div className="SendRow mt-1">
                    <Button
                        onClick={() => handleSendMessage(() => setLoading(false))}
                        className="send-btn"
                    >
                        {t('actions.send')}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default BotTab;
